import { connect } from 'react-redux';
import Packers from '../../components/General/Packers';
import { selectPacker, resetCurrentPacker } from '../../actions/settings_actions';

function mapStateToProps(state) {
  return {
    selectedCompany: state.header.selectedCompany,
    currentPacker: state.settings.currentPacker,
  };
}


export default connect(mapStateToProps, { selectPacker, resetCurrentPacker })(Packers);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/Packers.jsx